module.exports = __webpack_public_path__ + "static/media/icon_chevron_tail.2169758c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Stepper/assets/icon_chevron_tail.svg
// module id = 1503
// module chunks = 193